var _defs, _path, _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBaignoireMauvaisePosition3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "baignoire",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 891 658.89",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#000;stroke-width:5px;}.cls-1,.cls-2{stroke-miterlimit:10;}.cls-2{stroke:#fff;stroke-width:6px;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "bagnoire mauvaise r\xE9ponse 3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M467,1283h576s179,11,179-303H336C336,1146,384,1283,467,1283Z",
    transform: "translate(-333.5 -635.69)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 437.5,
    y: 470.31,
    width: 297,
    height: 148
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mauvaise_3",
    "data-name": "mauvaise 3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M516,1274c-11.52,34-70.52,14-59-20l78-197,18-187c4.49-36.29,13.43-61.91,30.5-68.11L616,1069Z",
    transform: "translate(-333.5 -635.69)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M764.37,851,714,901.87l78.63,110.41c12,21.23,53.82,2.83,41.77-18.4l-54.06-88.76L843,851Z",
    transform: "translate(-333.5 -635.69)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M583,1266c0,30.73,63,30.73,63,0l35-209V874l141-13,98,221c9.65,24.67,55.65,6.67,46-18L899,851c-11.68-63-13.35-141.26-75-128L620,775c-36.26,14.26-58.14,43.24-47,106l29,176Z",
    transform: "translate(-333.5 -635.69)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 629.84,
    cy: 82.66,
    r: 79.66
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBaignoireMauvaisePosition3);
export default __webpack_public_path__ + "static/media/baignoire_mauvaise_position_3.ae28f411036cb26739f9b166a8d6133d.svg";
export { ForwardRef as ReactComponent };